/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Filters_Invert_LabelInputs */



/**
* | output |
* | --- |
* | "Invert" |
*
* @param {Video_Filters_Invert_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_filters_invert_label = /** @type {((inputs?: Video_Filters_Invert_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Filters_Invert_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inverser")
	if (locale === "de") return /** @type {LocalizedString} */ ("Umkehren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Invertire")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Инвертировать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Invertir")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("倒置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("反転")
	if (locale === "hi") return /** @type {LocalizedString} */ ("औंधाना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Invertido")
	return /** @type {LocalizedString} */ ("Invert")
});